module.exports = __webpack_public_path__ + "static/media/ill-handle-it-mobile.381ccbff.png";